import React, {useEffect, useLayoutEffect, useState} from 'react';
import WebView from 'react-native-webview';
import {useDispatch} from 'react-redux';
import {
  hideLoader,
  showLoader,
} from '../../../commonComponents/Loader/loader.actions';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import Header from '../../../commonComponents/Header';

const LinkqCards = ({route}) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();
  const rechargeData = route?.params?.rechargeDetails;

  useLayoutEffect(() => {
    dispatch(showLoader());
  }, []);
  const onMessage = () => {};
  return (
    <View
      style={{
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        paddingLeft: insets.left,
        paddingRight: insets.right,
        flex: 1,
      }}>
      <Header
        isInternalPage={false}
        navigation={navigation}
        pageName={'Payment Option'}
        backGroundColor={'#FFFFFF'}
        translate={true}
      />
      <WebView
        style={{flex: 1}}
        incognito={true}
        nestedScrollEnabled
        onLoadEnd={() => dispatch(hideLoader())}
        onMessage={onMessage}
        source={{
          uri: rechargeData?.linkQUrl,
        }}
        onNavigationStateChange={state => {
          if (state?.url?.includes('WalletSuccess?status=success')) {
            rechargeData?.callbackFun('success');
            //navgation.pop();
          } else if (state?.url?.includes('WalletSuccess?status=cancel')) {
            rechargeData?.callbackFun('cancel');
            //navgation.pop();
          } else if (state?.url?.includes('WalletSuccess?status=failure')) {
            rechargeData?.callbackFun('failure');
            //navgation.pop();
          } else if (state?.url?.includes('Home')) {
            dispatch(hideLoader());
            rechargeData?.callbackFun('failure');
            //navgation.pop();
          }
        }}
      />
    </View>
  );
};

export default LinkqCards;
